import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import {
  CardContainer,
  CardBody,
  CardItem,
} from "../../components/ui/cardthreedimension";

interface ProjectCardProps {
  id?: string;
  slug?: string;
  imageUrl: string;
  title: string;
  category?: string;
}

const cardItemVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1.02,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

const hoverVariants = {
  scale: 1.05,
  boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.15)",
  transition: {
    type: "spring",
    stiffness: 300,
    damping: 20,
    duration: 0.4,
  },
};

const ProjectCard: React.FC<ProjectCardProps> = ({ id, slug, imageUrl, title }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (slug) {
      navigate(`/projects/${slug}`);
    } else if (id) {
      navigate(`/projects/${id}`);
    }
  };

  return (
    <CardContainer 
      className="w-full my-1.5 cursor-pointer" 
      containerClassName="w-full cursor-pointer"
      onClick={handleClick}
    >
      <motion.div
        variants={cardItemVariants}
        initial="hidden"
        animate="visible"
        whileHover={hoverVariants}
        className="w-full h-full flex flex-col cursor-pointer"
        onClick={handleClick}
      >
        <CardBody
          className="bg-white rounded-lg shadow-md overflow-hidden w-full h-auto flex flex-col cursor-pointer"
        >
          <CardItem translateZ={5} className="flex-shrink-0 cursor-pointer">
            <div className="w-full aspect-[4/3] overflow-hidden rounded-t-lg cursor-pointer">
              <img
                src={imageUrl}
                alt={title}
                className="block w-full h-full object-cover cursor-pointer"
                draggable={false}
              />
            </div>
          </CardItem>
          <CardItem
            translateZ={5}
            className="p-4 text-center font-bold content-text-size text-gray-800 flex-1 flex items-center justify-center cursor-pointer"
          >
            {title}
          </CardItem>
        </CardBody>
      </motion.div>
    </CardContainer>
  );
};

export default ProjectCard;
